import React, { useState } from "react";
import { toast } from "react-toastify";
import { useSentAssignmentMarkMutation } from "../../../features/assignment/assignmentApi";
import { formatDate } from "../../../utils/formatDate";

const MarkRow = ({
  assignment: {
    student_name,
    createdAt,
    repo_link,
    title,
    mark,
    totalMark,
    status,
    id
  },
}) => {

    const [score, setScore] = useState("")

    const [sentAssignmentMark, {isSuccess}] = useSentAssignmentMarkMutation();

    const handleSubmit = () => {
        if(Number(score) <= Number(totalMark)){
            sentAssignmentMark({id, data:{status: 'published', mark: Number(score)}})
        }else{
            toast.error("Given mark is crossing the total mark. Please recheck!")
        }
    }
  return (
    <tr>
      <td className="table-td">{title.slice(0, 30)}...</td>
      <td className="table-td">{formatDate(createdAt)}</td>
      <td className="table-td">{student_name}</td>
      <td className="table-td">{repo_link}</td>
      {status === "pending" ? ( <td className="table-td input-mark">
        <input max="100" placeholder="0" value={score} onChange={(e) => setScore(e.target.value)} />
        <svg
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          className="w-6 h-6 text-green-500 cursor-pointer hover:text-green-400"
          onClick={handleSubmit}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.5 12.75l6 6 9-13.5"
          />
        </svg>
      </td>) : (<td className="table-td">{mark}</td>)}
     
    </tr>
  );
};

export default MarkRow;
